import React, {Fragment} from 'react'
import {Popover, Transition} from '@headlessui/react'
import {Bars3Icon, XMarkIcon,} from '@heroicons/react/24/outline'
import {ArrowLeftEndOnRectangleIcon, ArrowRightEndOnRectangleIcon, AtSymbolIcon} from '@heroicons/react/20/solid'
import {useNavigate} from "react-router-dom";
import {logOutSession} from "../../requests/AppSession";
import {baseWebUrl} from "../../requests/NetworkRequestAuth0";
import LogoutButton from "../login/auth0/LogoutButton";

export default function HeaderNoLoginCheck({showMenu = true}) {
    let navigate = useNavigate();

    const [email, setEmail] = React.useState("");
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);

    // useEffect(() => {
    //     getEmail().then(email => {
    //         setEmail(email);
    //     })
    //
    //     return function cleanup() {
    //
    //     };
    // }, []);

    return (
        <Popover className="relative bg-white dark:bg-gray-900">
            <div className="flex items-center justify-between px-4 py-6 sm:px-6 md:justify-start md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1 md:w-0 md:flex-1">
                    <a onClick={() => {
                        navigate('/');
                    }}>
                        <span className="sr-only">VirtualTipz</span>
                        <img
                            className="block dark:hidden cursor-pointer h-8 w-auto sm:h-10"
                            src={baseWebUrl + "/VirtualTipzLogo.png"}
                            alt="VirtualTipzLogo"
                        />
                        <img
                            className="hidden dark:block cursor-pointer h-8 w-auto sm:h-10"
                            src={baseWebUrl + "/VirtualTipzLogoDark.png"}
                            alt="VirtualTipzLogo"
                        />
                    </a>
                </div>
                {showMenu &&
                    <div className="-my-2 -mr-2">
                        <Popover.Button
                            className="inline-flex items-center justify-center rounded-md bg-white dark:bg-gray-800 p-2 text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500">
                            <span className="sr-only">Open menu</span>
                            <Bars3Icon className="h-6 w-6" aria-hidden="true"/>
                        </Popover.Button>
                    </div>
                }
            </div>

            {showMenu &&
            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <Popover.Panel focus
                               className="absolute z-10 inset-x-0 top-0 origin-top-right transform p-2 transition">
                    <div
                        className="divide-y-2 divide-gray-50 rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="px-5 pt-5 pb-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <img
                                        className="block dark:hidden h-8 w-auto"
                                        src={baseWebUrl + "/VirtualTipzLogo.png"}
                                        alt="VirtualTipzLogo"
                                    />
                                    <img
                                        className="hidden dark:block h-8 w-auto"
                                        src={baseWebUrl + "/VirtualTipzLogoDark.png"}
                                        alt="VirtualTipzLogo"
                                    />
                                </div>
                                <div className="-mr-2">
                                    <Popover.Button
                                        className="inline-flex items-center justify-center rounded-md bg-white dark:bg-gray-800 p-2 text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500">
                                        <span className="sr-only">Close menu</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                    </Popover.Button>
                                </div>
                            </div>
                            <div className="mt-6">
                                <nav className="grid grid-cols-1 gap-7">
                                    {isLoggedIn ?
                                        <a
                                            onClick={() => {
                                                logOutSession().then(() => {
                                                    setIsLoggedIn(false);
                                                    navigate('/login/mobile');
                                                })
                                            }}
                                            className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                        >
                                            <div
                                                className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                <ArrowRightEndOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
                                            </div>
                                            <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Logout</div>
                                        </a>
                                        :
                                        <>
                                            <a
                                                onClick={() => {
                                                    navigate('/login/mobile');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ArrowLeftEndOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Login</div>
                                            </a>
                                            <a
                                                onClick={() => {
                                                    navigate('/signup/mobile');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <ArrowRightEndOnRectangleIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Signup</div>
                                            </a>
                                            {isLoggedIn &&
                                                <LogoutButton/>
                                            }
                                            {/*<div className="relative">*/}
                                            {/*    <div className="absolute inset-0 flex items-center" aria-hidden="true">*/}
                                            {/*        <div className="w-full border-t border-gray-300" />*/}
                                            {/*    </div>*/}
                                            {/*    <div className="relative flex justify-center">*/}
                                            {/*        <span className="bg-white px-2 text-sm text-gray-500"></span>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            {/*<a*/}
                                            {/*    onClick={() => {*/}
                                            {/*        navigate('/dancer');*/}
                                            {/*    }}*/}
                                            {/*    className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"*/}
                                            {/*>*/}
                                            {/*    /!*<div*!/*/}
                                            {/*    /!*    className="flex h-10 w-10 text-sm flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">*!/*/}
                                            {/*    /!*    /!*<BuildingLibraryIcon className="h-6 w-6" aria-hidden="true"/>*!/*!/*/}
                                            {/*    /!*</div>*!/*/}
                                            {/*    <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Dancer Login</div>*/}
                                            {/*</a>*/}
                                            {/*<a*/}
                                            {/*    onClick={() => {*/}
                                            {/*        navigate('/admin');*/}
                                            {/*    }}*/}
                                            {/*    className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"*/}
                                            {/*>*/}
                                            {/*    /!*<div*!/*/}
                                            {/*    /!*    className="flex h-10 w-10 text-sm flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">*!/*/}
                                            {/*    /!*    /!*<BuildingLibraryIcon className="h-6 w-6" aria-hidden="true"/>*!/*!/*/}
                                            {/*    /!*</div>*!/*/}
                                            {/*    <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Admin Login</div>*/}
                                            {/*</a>*/}
                                            {email && <a
                                                onClick={() => {
                                                    navigate('/validateemail');
                                                }}
                                                className="-m-3 cursor-pointer flex items-center rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <div
                                                    className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-pink-400 text-white">
                                                    <AtSymbolIcon className="h-6 w-6" aria-hidden="true"/>
                                                </div>
                                                <div className="ml-4 text-base font-medium text-gray-900 dark:text-gray-100">Validate
                                                    Email
                                                </div>
                                            </a>}
                                        </>
                                    }
                                </nav>
                            </div>
                        </div>
                    </div>
                </Popover.Panel>
            </Transition>
            }
        </Popover>
    )
}
